function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var WelcomeTemplate = require('./welcome.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WelcomeOverlay = /*#__PURE__*/function () {
  function WelcomeOverlay(app, mod) {
    _classCallCheck(this, WelcomeOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, false, true);
  }
  return _createClass(WelcomeOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "renderCustom",
    value: function renderCustom() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var his_self = this.mod;
      if (document.querySelector('.winter')) {
        this.overlay.zIndex = his_self.winter_overlay.overlay.zIndex + 2;
      }
      var img = '';
      if (obj.img) {
        img = obj.img;
      }
      var title = '';
      if (obj.title) {
        title = obj.title;
      }
      var text = '';
      if (obj.text) {
        text = obj.text;
      }
      this.overlay.show(WelcomeTemplate('', img, title, text));
      this.pushHudUnderOverlay();
      this.overlay.pullOverlayToFront();
      if (obj.title) {
        document.querySelector('.welcome-title').innerHTML = obj.title;
      }
      if (obj.text) {
        document.querySelector('.welcome-text').innerHTML = obj.text;
      }
      if (obj.card) {
        his_self.app.browser.addElementToSelector("<div class=\"welcome-card\">".concat(his_self.returnCardImage(obj.card), "<div>"), '.welcome');
      }
      if (obj.styles) {
        for (var z = 0; z < obj.styles.length; z++) {
          var s = obj.styles[z];
          document.querySelector('.welcome').style[s.key] = s.val;
        }
      }
      var overlay_zindex = parseInt(this.overlay.zIndex);
      document.querySelector('.welcome').style['zIndex'] = overlay_zindex;
      document.querySelector('.welcome').style['display'] = 'block';

      // this will clear any ACKNOWLEDGE
      this.attachEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.overlay.show(WelcomeTemplate(faction));
      this.pushHudUnderOverlay();

      // COMBOS
      if (faction === 'hapsburg_papacy') {
        document.querySelector('.welcome-title').innerHTML = "Hapsburgs and Papacy";
        document.querySelector('.welcome-text').innerHTML = "You are playing as both Hapsburg and Papacy this game.";
      }
      if (faction === 'france_ottoman') {
        document.querySelector('.welcome-title').innerHTML = "France and Ottoman Empire";
        document.querySelector('.welcome-text').innerHTML = "You are playing as both France and the Ottoman Empire.";
      }
      if (faction === 'protestant_england') {
        document.querySelector('.welcome-title').innerHTML = "Protestants and England";
        document.querySelector('.welcome-text').innerHTML = "You are playing as both the Protestants and the English.";
      }

      // PAPACY
      if (faction === 'papacy') {
        document.querySelector('.welcome-title').innerHTML = "You are the Papacy";
        document.querySelector('.welcome-text').innerHTML = "Since God has given us the Papacy, let us enjoy it.";
      }

      // PROTESTANT
      if (faction === 'protestant') {
        document.querySelector('.welcome-title').innerHTML = "You are the Protestants";
        document.querySelector('.welcome-text').innerHTML = "\n\t\t\t  The Saxon princes are weak and divided.\n\t\t\t  <p></p>\n\t\t\t  But from their gentle shelter,\n\t\t\t  <p></p>\n\t\t\t  Great Oaks may yet spread across Europe...\n\t\t\t";
      }

      // OTTOMAN
      if (faction === 'ottoman') {
        document.querySelector('.welcome-title').innerHTML = "You are the Turks";
        document.querySelector('.welcome-text').innerHTML = "\n\t\t\t  \"If we will not learn out of the Scriptures, we must learn out of the Turk\u2019s scabbard...\"\n\t\t\t  </br>-- <i>Martin Luther</i>\n\t\t\t";
      }

      // ENGLAND
      if (faction === 'england') {
        document.querySelector('.welcome-title').innerHTML = "You are England";
        document.querySelector('.welcome-text').innerHTML = "\n\t\t\t  This fortress built by Nature for herself </br> Against infection and the hand of war, \n\t\t\t";
      }

      // FRANCE
      if (faction === 'france') {
        document.querySelector('.welcome-title').innerHTML = "You are the French";
        document.querySelector('.welcome-text').innerHTML = "\n\t\t\t  The French are wiser than they seem...\n\t\t\t  </br>\n\t\t\t  <i>-- Francis Bacon</i>\n\t\t\t";
      }

      // HAPSBURG
      if (faction === 'hapsburg') {
        document.querySelector('.welcome-title').innerHTML = "You are the Hapsburg Dynasty";
        document.querySelector('.welcome-text').innerHTML = "\n\t\t\t  El imperio donde nunca se pone el sol...\n\t\t\t";
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var his_self = this.mod;
      $('.welcome').on('click', function () {
        // don't hide() AND removeOnClose
        //this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
      $('.saito-overlay:has(> .welcome) + .saito-overlay-backdrop').on('click', function () {
        //this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
    }
  }]);
}();
module.exports = WelcomeOverlay;